<div class="custom-pt custom-container">
  @if (isLoading) {
  <app-skeleton></app-skeleton>
  } @else if (loadError) {
  <p role="alert">{{ loadError }}</p>
  @if (sendoutState === SendoutState.New) {
  <a routerLink="/sendout/create/select-template" [queryParams]="{ sendoutDate: requestedSendoutDate }">Tilbage til skabelonvalg</a>
  }
  } @else if (!this.sendout || !this.template) {
  <app-skeleton></app-skeleton>
  } @else if (!canViewSendout) {
  <p role="alert">Du har ikke længere adgang til udsendelsen.</p>
  } @else {
  @if ((this.sendout.status == SendoutStatus.Draft || this.sendoutState == SendoutState.New) && canChangeSendout) {
  <app-main-heading-subtext headingText="Redigér udsendelse" subText="På denne side kan du redigere alle elementer af din udsendelse, så den kommer til at se ud, som du gerne vil have det. Billede, overskrift, brødtekst og meget mere. Når du laver ændringer vil du se det i visningen på højre hånd." extraClasses="activity-margin"></app-main-heading-subtext>
  } @else if(sendout.sendoutType == SendoutType.MultiStore) {
  <app-main-heading-subtext headingText="Udsendelse på vegne af flere butikker" subText="Denne udsendelse er opsat på vegne af flere butikker og kan derfor ikke redigeres." extraClasses="activity-margin"></app-main-heading-subtext>
  } @else {
  <app-main-heading-subtext headingText="Udsendelse" extraClasses="activity-margin"></app-main-heading-subtext>
  }

  <div class="form-container">
    <form [formGroup]="sendoutForm">
      <app-main-heading extraClasses="create-template" headingText="Generelt"></app-main-heading>

      <!-- general data fields -->
      <div class="general-fields-container d-flex">
        <div class="w-md-50" style="padding-right: 2em;">
          @if (sendout.sendoutType == SendoutType.SingleStore && canChangeSendout) {
          <app-calendar-date-picker-field label="Udsendelsesdato" [formGroup]="sendoutForm" controlName="sendoutDate" [storeId]="store?.id || 0" [sendoutId]="sendout.id || 0" [overrideLocks]="canManageSendouts"></app-calendar-date-picker-field>

          <app-form-field label="Kontaktperson i butik" placeholder="Kontaktperson i butik" [icon]="false" [formGroup]="sendoutForm" controlName="contactPerson" [enablePasteButton]="true"></app-form-field>
          } @else {
          <app-date-field label="Udsendelsesdato" placeholder="Udsendelsesdato" [formGroup]="sendoutForm" controlName="sendoutDate"></app-date-field>
          <!-- <app-form-field label="Udsendelsesdato" [formGroup]="sendoutForm" controlName="sendoutDate"></app-form-field> -->
          }

        </div>

        <div class="w-md-50" style="padding-right: 2em;">
          @if (sendout.sendoutType == SendoutType.SingleStore && canChangeSendout) {
          <app-form-field label="Event eller personlig aftale" placeholder="Intet event valgt" [icon]="true" iconLocation="../../../../assets/edit-event.svg" iconClass="top" className="login-form-field-width" [formGroup]="sendoutForm" controlName="eventName" iconTooltip="Tilføj event" (iconEvent)="editEventIconClick()"></app-form-field>
          }
          <app-form-field label="Udsendelsesnavn" placeholder="Udsendelsesnavn" className="login-form-field-width" [icon]="false" [formGroup]="sendoutForm" controlName="sendoutName" [enablePasteButton]="true"></app-form-field>
        </div>
      </div>



      <app-main-heading extraClasses="create-template" headingText="Udsendelse"></app-main-heading>

      <!-- email fields -->
      <div class="d-flex flex-column-reverse flex-md-row gap-4 gap-md-0 email-details-container">
        <div class="w-md-50" style="padding-right: 2em;">
          <app-form-field label="Emnelinje" placeholder="Emnelinje" [icon]="false" [formGroup]="sendoutForm" controlName="contentSubjectLine" [enablePasteButton]="true"></app-form-field>

          <app-form-field label="Preheader" placeholder="Preheader" [icon]="false" [formGroup]="sendoutForm" controlName="contentPreheader" [enablePasteButton]="true"></app-form-field>

          <app-img-grid [formGroup]="sendoutForm" controlName="contentImageUrl" [templateImages]="template.availableImages"></app-img-grid>

          <app-form-field label="Overskrift" placeholder="Overskrift" [icon]="false" [formGroup]="sendoutForm" controlName="contentHeadline" [enablePasteButton]="true"></app-form-field>

          <app-rte-form-field label="Brødtekst" placeholder="Brødtekst" formControlName="contentBodyCopy" [maxLength]="1000" style="margin-bottom: 10px;"></app-rte-form-field>

          <app-link-form-field label="Link" placeholder="Link" [formGroup]="sendoutForm" controlName="contentCtaUrl" [enablePasteButton]="true" [event]="selectedEvent"></app-link-form-field>

          <app-form-field label="Knap tekst" placeholder="Knap tekst" [icon]="false" [formGroup]="sendoutForm" controlName="contentCtaText" [enablePasteButton]="true"></app-form-field>

          <app-rte-form-field label="Disclaimer tekst" placeholder="Disclaimer tekst" formControlName="contentDisclaimer" [maxLength]="1000" style="margin-bottom: 10px;"></app-rte-form-field>
        </div>
        <div class="w-md-50 email-container">
          <app-email [templateName]="template.templateName" [subjectLine]="sendoutForm.get('contentSubjectLine')?.value" [preheader]="sendoutForm.get('contentPreheader')?.value" [headline]="sendoutForm.get('contentHeadline')?.value" [bodyCopy]="sendoutForm.get('contentBodyCopy')?.value" [ctaUrl]="this.sendoutForm.get('contentCtaUrl')?.value == '{{event URL}}' ? (this.selectedEvent != null ? this.selectedEvent.link : '' ): this.sendoutForm.get('contentCtaUrl')?.value" [ctaText]="sendoutForm.get('contentCtaText')?.value" [disclaimer]="sendoutForm.get('contentDisclaimer')?.value" [contentImageUrl]="sendoutForm.get('contentImageUrl')?.value" [points]="previewPoints" [storeSignature]="previewStoreSignature"></app-email>
        </div>
      </div>

      <!-- email fields ends -->
    </form>

    <form [formGroup]="emailForm" (ngSubmit)="sendProofEmail()">
      <div class="d-flex flex-column-reverse flex-md-row gap-4 gap-md-0 email-details-container">
        <div class="w-md-50" style="padding-right: 2em;">
          <app-main-heading extraClasses="create-template mt-25" headingText="Test"></app-main-heading>
          <app-form-field label="Email adresse" placeholder="Email adresse" [icon]="false" [sendBtn]="true" [formGroup]="emailForm" controlName="email" (childEvent)="sendProofEmail()"></app-form-field>
        </div>
        <div class="w-md-50" style="padding-right: 49px;"></div>
      </div>

    </form>
  </div>

  <!-- buttons -->
  @if (sendout.sendoutType == SendoutType.SingleStore && canChangeSendout) {
  <div class="d-flex flex-column flex-md-row align-items-center justify-content-between margin-bottom margin-btn gap-3">
    <div class="d-flex gap-3 flex-column flex-md-row width-100 button-container">

      @if (sendoutState == SendoutState.Existing && canChangeSendout) {
      <app-stroked-button buttonText="Slet udsendelse" className="full-width-btn edit-email-sendout" (navLinkClicked)="sletUdsendelseClick()"></app-stroked-button>
      }
      @if (sendoutState == SendoutState.New) {
      <filled-button buttonText="Tilbage" className="back-btn width" (childEvent)="goToSelectEventPage()"></filled-button>
      }
    </div>

    <div class="d-flex gap-3 flex-column flex-md-row width-100 button-container">
      @if (storeWorkflow) {
      @if (sendout.status == SendoutStatus.Draft) {
      <app-stroked-button buttonText="Gem" className="full-width-btn edit-email-sendout" [disabled]="!sendoutForm.dirty" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>
      <filled-button buttonText="Send til godkendelse" className="approval-btn margin width" [disabled]="!sendoutForm.valid" (childEvent)="onSendoutFormSubmit(SendoutStatus.AwaitingApproval, sendoutForm.dirty)"></filled-button>
      } @else if (sendoutState == SendoutState.New) {
      <app-stroked-button buttonText="Gem" className="full-width-btn edit-email-sendout" [disabled]="!sendoutForm.dirty" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>
      <filled-button buttonText="Send til godkendelse" className="approval-btn margin width" [disabled]="!sendoutForm.valid" (childEvent)="onSendoutFormSubmit(SendoutStatus.AwaitingApproval, sendoutForm.dirty)"></filled-button>
      }
      @if (sendout.status == SendoutStatus.Approved || sendout.status == SendoutStatus.Rejected || sendout.status == SendoutStatus.AwaitingApproval) {
      <app-stroked-button buttonText="Rediger" className="full-width-btn edit-email-sendout" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>
      }

      }
      @else {

      @if (sendout.status == SendoutStatus.AwaitingApproval || sendout.status == SendoutStatus.Approved || sendout.status == SendoutStatus.Rejected) {
      <app-stroked-button buttonText="Rediger" className="full-width-btn edit-email-sendout" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>
      <filled-button buttonText="Afvis" className="create-template width" [disabled]="sendout.status == SendoutStatus.Rejected" (childEvent)="rejectionClick(false)"></filled-button>
      <filled-button buttonText="Godkend" className="approval-btn margin width" [disabled]="sendout.status == SendoutStatus.Approved" (childEvent)="onSendoutFormSubmit(SendoutStatus.Approved)"></filled-button>
      } @else if (sendout.status == SendoutStatus.Draft) {
      <app-stroked-button buttonText="Gem" className="full-width-btn edit-email-sendout" [disabled]="!sendoutForm.dirty" (navLinkClicked)="onSendoutFormSubmit(SendoutStatus.Draft)"></app-stroked-button>
      <filled-button buttonText="Afvis" className="create-template width" [disabled]="!sendoutForm.dirty || !sendoutForm.valid" (childEvent)="rejectionClick(true)"></filled-button>
      <filled-button buttonText="Godkend" className="approval-btn margin width" [disabled]="!sendoutForm.dirty || !sendoutForm.valid" (childEvent)="onSendoutFormSubmit(SendoutStatus.Approved, true)"></filled-button>

      }
      }


    </div>
  </div>
  }
  @if (sendoutState == SendoutState.Existing) {
  <app-main-heading extraClasses="create-template" headingText="Kommentarer"></app-main-heading>
  <app-sendout-comments [sendoutId]="sendout.id"></app-sendout-comments>
  }
  }
</div>
